/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListOfFileDto } from './listOfFileDto.schema';

export const DailyActivityMonitoringLogDetailDto = zod.object({
  "id": zod.string().uuid().optional(),
  "memberId": zod.string().uuid().optional(),
  "memberName": zod.string().optional(),
  "particularTypeId": zod.number().optional(),
  "location": zod.string().optional(),
  "updatedContactNumber": zod.string().optional(),
  "files": zod.lazy(() => ListOfFileDto).optional()
});

export type DailyActivityMonitoringLogDetailDto = zod.input<typeof DailyActivityMonitoringLogDetailDto>;
export type DailyActivityMonitoringLogDetailDtoOutput = zod.output<typeof DailyActivityMonitoringLogDetailDto>;
